import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGoogleLogin } from '@react-oauth/google';
import image from './images/GSignIn.png';

const SignIn = () => {
  const navigate = useNavigate();
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const login = useGoogleLogin({
    onSuccess: async (response) => {
      try {
        setLoading(true);
        const res = await fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
          headers: { Authorization: `Bearer ${response.access_token}` },
        });

        const data = await res.json();
        const userEmail = data.email;

        if (!userEmail) throw new Error("Email not found");

        sessionStorage.setItem('userEmail', userEmail);
        navigate('/main');
      } catch (err) {
        setMessage('Login failed. Try again.');
        console.error(err);
        setLoading(false);
      }
    },
    onError: () => setMessage('Google login failed'),
  });

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>Sign In</h1>

      {loading ? (
        <p style={styles.loadingText}>Signing you in...</p>
      ) : (
        <button onClick={login} style={styles.googleButton}>
          <img src={image} alt="Sign in with Google" width="250" height="120" />
        </button>
      )}

      {message && <p style={styles.errorText}>{message}</p>}
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    backgroundColor: '#f5f5f5',
    fontFamily: 'Arial, sans-serif',
    textAlign: 'center',
  },
  heading: {
    fontSize: '60px',
    fontWeight: 'bold',
    color: 'pink',
    marginBottom: '40px',
  },
  googleButton: {
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    transition: 'transform 0.2s ease',
  },
  loadingText: {
    fontSize: '20px',
    color: '#555',
  },
  errorText: {
    marginTop: '20px',
    color: 'red',
    fontSize: '18px',
  },
};

export default SignIn;
